/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/**
 * Custom element wrapping the "Notify me" button rendered in place of the
 * Add-to-cart button when the current variant is sold out.
 *
 * On click, finds the global <klaviyo-bis-dialog> (rendered once via
 * `snippets/klaviyo-bis-modal.liquid`) and opens it primed for this
 * variant. If BIS is disabled (no dialog on page), clicks are a no-op.
 */
class NotifyMeComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.notify-me-button');
    this.button?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    const dialog = /** @type {any} */ (document.getElementById('klaviyo-bis-dialog'));
    if (!dialog?.openForVariant) return;
    dialog.openForVariant({
      variantId: this.dataset.variantId,
      productTitle: this.dataset.productTitle,
      variantTitle: this.dataset.variantTitle,
    });
  };
}

if (!customElements.get('notify-me-component')) {
  customElements.define('notify-me-component', NotifyMeComponent);
}
